import { IKogIcon } from "@/main/@types/interfaceIcons";

export function PaidIcon({ height = "50px", width = "50px", color = "currentColor" }: IKogIcon) {
	return (
		<svg
			version="1.0"
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 289.000000 439.000000"
			preserveAspectRatio="xMidYMid meet"
		>
			<g transform="translate(0.000000,439.000000) scale(0.100000,-0.100000)" fill={color} stroke="none">
				<path
					d="M1404 4206 c-18 -13 -19 -30 -22 -259 l-3 -244 -157 -5 c-241 -8
          -391 -45 -587 -146 -164 -84 -274 -225 -337 -432 -29 -94 -36 -284 -14 -370
          35 -137 144 -278 284 -368 173 -111 311 -166 645 -257 109 -30 202 -57 206
          -59 4 -3 57 -16 117 -30 331 -75 627 -195 776 -315 131 -105 178 -201 178
          -361 0 -256 -140 -462 -385 -567 -164 -71 -281 -93 -530 -100 -327 -9 -661 45
          -1026 167 -115 38 -218 70 -228 70 -23 0 -51 -31 -51 -57 0 -37 33 -60 145
          -101 196 -71 440 -138 633 -172 59 -10 293 -40 319 -40 9 0 13 -64 15 -251 3
          -235 4 -252 22 -265 25 -18 57 -18 82 0 18 13 19 30 22 260 l3 246 52 0 c135
          1 363 40 502 85 293 96 503 321 546 584 12 74 11 225 -2 281 -27 118 -129 264
          -242 344 -169 120 -463 232 -912 346 -276 70 -415 113 -588 182 -238 94 -333
          168 -423 332 -33 61 -37 77 -42 161 -6 118 15 220 70 335 83 173 251 285 518
          345 102 23 450 32 618 15 146 -14 432 -60 558 -90 109 -26 138 -25 164 2 21
          23 19 51 -5 76 -25 27 -366 100 -595 127 -74 8 -154 18 -177 21 l-42 5 -3 245
          c-3 230 -4 247 -22 260 -11 8 -29 14 -41 14 -12 0 -30 -6 -41 -14z"
				/>
			</g>
		</svg>
	);
}
